import { CurrentSectionSpiIt } from '@ingenico/react-section-utils';
import { deviceManagementContainer } from './container.const';
import { ConfigurationFormGeneratorService } from './domain/business/services/configurationFormGenerator.service';
import { DeviceManagementService } from './domain/business/services/deviceManagement.service';
import { ScreenShareService } from './domain/business/services/screen-share.service';
import { DeviceManagementApi } from './domain/hexa/deviceManagementApi.service';
import type { DeviceManagementSpiPort } from './domain/hexa/ports/spi.model';

export function deviceManagementContainerInit(spi: DeviceManagementSpiPort): void {
  deviceManagementContainer.bind(CurrentSectionSpiIt).toConstantValue(spi);
  deviceManagementContainer.bind(DeviceManagementService).toSelf();
  deviceManagementContainer.bind(ScreenShareService).toSelf();
  deviceManagementContainer.bind(ConfigurationFormGeneratorService).toSelf();
  deviceManagementContainer.bind(DeviceManagementApi).toSelf();
}
